module.exports = __webpack_public_path__ + "assets/img/38_352_big.5ca07338.jpg";